/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable extra-rules/no-commented-out-code */
import { call, all, select, put, fork } from 'redux-saga/effects';
import format from 'date-fns/format';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  setValueInAsyncStorage,
  getValueFromAsyncStorage,
  isCanada,
  sanitizeEntity,
  convertToISOString,
  removeSessionStorage,
  parseBoolean,
  getEddSessionState,
  getDateObject,
} from '@tcp/core/src/utils';
import { getUserInfoSaga } from '@tcp/core/src/components/features/account/User/container/User.saga';
import { navigateXHRAction } from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.action';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  resetCartCache,
  setApplePayDefault,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  AddToCartError,
  setExpressAfterPayDone,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import {
  getEddABState,
  getItemsWithEDD,
  getOrderEddDates,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import { formatEddPersistParams } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.saga.util.js';
import InjectConfirmationDynamicStore from '@tcp/core/src/components/features/CnC/Confirmation/container/ConfirmationDynamicStore';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import { getIsBonusPointDayEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getBonusPointsDay as getBonusPointsDayAbstractor } from '@tcp/core/src/services/abstractors/CnC/Coupon';
import {
  submitOrderFn,
  appleVenmoSubmitOrderFn,
  requestPersonalizedCouponsFn,
} from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import { getAssociateId } from '../../../account/User/container/User.selectors';
import {
  updatePaymentOnOrder,
  getServerErrorMessage,
} from '../../../../../services/abstractors/CnC/Checkout';
import selectors, {
  isGuest,
  isExpressCheckout,
  getMprId,
  getPickupValues,
  getShippingValues,
  getLoginV2FlowEnabled,
} from './Checkout.selector';
import utility from '../util/utility';
import constants, { CHECKOUT_ROUTES } from '../Checkout.constants';
import { callPickupSubmitMethod } from './Checkout.saga.util';
import { validateAndSubmitEmailSignup } from './CheckoutExtended.saga.util';
import { getAppliedCouponListState } from '../../common/organism/CouponAndPromos/container/Coupon.selectors';

import {
  getSetCouponsValuesActn,
  getSetRewardPointsOrderConfActn,
  getSetOrderConfirmationActn,
  getSetOrderProductDetails,
  setCouponLoadingState,
  setOrderDetailsForConfirmation,
} from '../../Confirmation/container/Confirmation.actions';
import ConfirmationSelectors from '../../Confirmation/container/Confirmation.selectors';
import BagPageSelectors, {
  getIsPlccCheckoutEnabled,
} from '../../BagPage/container/BagPage.selectors';
import {
  getSinglePageCheckoutSectionState,
  getSubmitOrderButtonState,
} from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import CHECKOUT_ACTIONS, {
  getSetCheckoutStage,
  getSetBillingValuesActn,
  isExpressCallThroughPlccICFailure,
  setSubmitOrderError,
  setExpressAfterpayFlow,
  setAfterPayPaymentProgress,
  setSubmitOrderErrorCode,
} from './Checkout.action';
import { resetAirmilesReducer } from '../../common/organism/AirmilesBanner/container/AirmilesBanner.actions';
import {
  resetCouponReducer,
  getCouponList,
  setBonusPointDay,
} from '../../common/organism/CouponAndPromos/container/Coupon.actions';
import { getGrandTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import {
  setSpcButtonLoader,
  updateSubmitOrderButtonState,
  recalibrateSectionStates,
  isExpressUserCallDone,
  isNonCachedCartDataCallDone,
  triggerCheckoutWithPayment,
} from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import {
  PAYMENT_METHOD_VENMO,
  SPC_BUTTON,
  SPC_SECTION,
  SUBMIT_ORDER_BUTTON_STATE,
} from '../../SinglePageCheckout/container/SinglePageCheckout.constants';
import { CONTACT_FORM } from '../../SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import { resetPLCCInstantCardApplication } from '../../../browse/ApplyCardPage/container/ApplyCard.actions';
import { getContactFormValuesFromSS } from '../../SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import BAG_PAGE_ACTIONS from '../../BagPage/container/BagPage.actions';
import ApplyCardDynamicStore from '../../../browse/ApplyCardPage/container/ApplyCardDynamicStore';

const {
  // isVenmoPaymentAvailable,
  getCurrentOrderId,
  getSmsNumberForBillingOrderUpdates,
  getIsPaymentDisabled,
  getCurrentLanguage,
  getBillingValues,
  getShipmentMethods,
  getSavedShipmentId,
} = selectors;

function extractCouponInfo(personalizedOffersResponse) {
  try {
    return personalizedOffersResponse.coupon.map((coupon) => {
      let startDate;
      let endDate;
      let isPastStartDate;
      let categoryType;
      let description;
      const { couponCode, legalText, promotion } = coupon;
      /* istanbul ignore else */
      if (promotion) {
        const { categoryType: catType } = promotion;
        const proStartDate = getDateObject(convertToISOString(promotion.startDate));
        startDate = promotion.startDate && format(proStartDate, 'MMM do, yyyy');
        isPastStartDate =
          promotion.startDate && differenceInMilliseconds(getDateObject(), proStartDate) > 0; // check user browser date to server date
        endDate =
          promotion.endDate &&
          format(getDateObject(convertToISOString(promotion.endDate)), 'MMM do, yyyy');
        categoryType = catType;
        description = promotion.shortDescription;
      }

      return {
        code: couponCode,
        description,
        disclaimer: legalText && sanitizeEntity(legalText),
        endDate,
        isPastStartDate,
        startDate,
        categoryType,
      };
    });
  } catch (error) {
    return [];
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* loadPersonalizedCoupons({
  isElectiveBonus,
  currencyCode,
  orderItems: cartItems,
  paymentsList: payments,
  userDetails: { emailAddress },
  orderDetails: { orderNumber },
  token,
}) {
  yield InjectConfirmationDynamicStore();
  const shippingMethods = yield select(getShipmentMethods);
  const shipmentId = yield select(getSavedShipmentId);
  const itemsWithEdd = yield select(getItemsWithEDD);
  const selectedShipmentMethod =
    shippingMethods && shippingMethods.find((shipData) => shipData.id === shipmentId);
  const orderEddDates = yield select(getOrderEddDates);
  const isGetOfferPayload = true;
  const eddItemLevelInfo = formatEddPersistParams({
    itemsWithEdd,
    orderEddDates,
    selectedShippingCode: selectedShipmentMethod?.code,
    isGetOfferPayload,
  });

  if (
    eddItemLevelInfo &&
    eddItemLevelInfo.orderItemsList &&
    eddItemLevelInfo.orderItemsList.length
  ) {
    const eddABState = yield select(getEddABState);
    const isEddABStateFlag = parseBoolean(getEddSessionState(eddABState));
    if (isEddABStateFlag) {
      eddItemLevelInfo.c_showEDD = 'true';
    }
  }
  const isCaSite = yield call(isCanada);
  const isGuestUser = yield select(isGuest);
  const associateId = yield select(getAssociateId);
  const mprData = yield select(getMprId);
  const isUsSite = !isCaSite;
  let couponList = yield select(getAppliedCouponListState);
  if (couponList && couponList.size > 0) {
    couponList = couponList.map((val) => ({ id: val.id }));
  }
  const { US_LOCATION_ID, CA_LOCATION_ID } = constants;
  const { personalizedOffersResponse, orderResponse } = yield call(requestPersonalizedCouponsFn, {
    orderNumber,
    emailAddress,
    locationId: isUsSite ? US_LOCATION_ID : CA_LOCATION_ID,
    couponList,
    isElectiveBonus,
    currencyCode,
    payments,
    cartItems,
    isGuestUser,
    mprData,
    token,
    associateId,
    ...eddItemLevelInfo,
  });
  let couponsInfo = [];
  /* istanbul ignore else */
  if (personalizedOffersResponse && personalizedOffersResponse?.coupon) {
    couponsInfo = extractCouponInfo(personalizedOffersResponse);
    yield put(getSetCouponsValuesActn(couponsInfo)); // to be done at time of confirmation page as it require new reducer
  }
  const brierelyPointsInfo = {};
  if (orderResponse) {
    if (orderResponse.pointsToNextReward === -1) {
      brierelyPointsInfo.pointsToNextReward = 0;
    } else {
      brierelyPointsInfo.pointsToNextReward = orderResponse.pointsToNextReward;
    }
    if (orderResponse.userPoints === -1) {
      brierelyPointsInfo.estimatedRewards = null;
    } else {
      brierelyPointsInfo.estimatedRewards = orderResponse.userPoints;
    }
    if (orderResponse.earnedReward) {
      brierelyPointsInfo.earnedReward = orderResponse.earnedReward;
    }
    const summary = yield select(ConfirmationSelectors.getConfirmationSummary);
    const updatedSummary = { ...summary, ...brierelyPointsInfo };
    yield put(getSetRewardPointsOrderConfActn(updatedSummary));
  }
}

export function* setDetailsInAsyncStorage(res) {
  const isGuestUser = yield select(isGuest);
  if (isGuestUser) {
    const { userDetails: { firstName, lastName, emailAddress, phoneNumber, zipCode } = {} } = res;
    const userDetail = {
      firstName,
      lastName,
      emailAddress,
      phoneNumber,
      zipCode,
    };
    const userDetailValue = JSON.stringify(userDetail);
    const userDetailString = yield call(getValueFromAsyncStorage, constants.USER_ACCOUNT_KEY);
    if (userDetailValue && userDetailValue !== userDetailString) {
      setValueInAsyncStorage(constants.USER_ACCOUNT_KEY, userDetailValue);
    }
  }
}

export const getProdDataForMonetate = (items) => {
  return items.map((item) => {
    return {
      sku: item?.productId,
      pid: item?.c_prodPartNo,
      quantity: item?.quantity,
      currency: 'USD',
      value: item?.price.toString(),
    };
  });
};

export const getStoreAddress = (addressObject) => {
  const {
    addressLine1 = '',
    city = '',
    state = '',
    zipCode = '',
    addressLine2 = '',
    country = '',
  } = addressObject || {};
  return {
    addressLine1,
    city,
    state,
    zipCode,
    country,
    addressLine2,
  };
};

const getBillingAddress = (address, email, phoneNumber) => {
  return {
    address1: address?.addressLine1,
    address2: address?.addressLine2,
    c_addressId: address?.addressId,
    c_addressName: null,
    c_addressType: null,
    c_emailAddress: email,
    c_sameAsShippingAddress: address?.sameAsShipping,
    city: address?.city,
    countryCode: address?.country,
    firstName: address?.firstName,
    lastName: address?.lastName,
    phone: phoneNumber,
    postalCode: address?.zipCode,
    stateCode: address?.state,
  };
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* submitOrderProcessing(adyenRequest) {
  const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
  const isVenmoSaveSelected = yield select(selectors.isVenmoPaymentSaveSelected);
  const venmoData = yield select(selectors.getVenmoData);
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  const isPaymentDisabled = yield select(getIsPaymentDisabled);
  let venmoPayload = {};
  let res = '';
  if (!isPaymentDisabled && isVenmoInProgress && venmoData) {
    const { nonce: venmoNonce, deviceData: venmoDeviceData, username, userName } = venmoData;
    const email = yield select(selectors.getVenmoUserEmail);
    let billingAddress = {};
    const reduxState = yield select();
    const contactData = getSinglePageCheckoutSectionState()(reduxState, SPC_SECTION.CONTACT);
    const contactFormValuesFromSS = getContactFormValuesFromSS(contactData);
    const { emailAddress, phoneNumber } = { ...contactFormValuesFromSS };
    const orderItems = yield select(BagPageSelectors.getOrderItems);
    const hasEcomItems = orderItems?.find(
      (item) => item.getIn(['productInfo', 'orderType']) === constants.ORDER_ITEM_TYPE.ECOM
    );
    const { address } = yield select(getShippingValues);
    if (hasEcomItems) {
      billingAddress = getBillingAddress(address, email, phoneNumber);
    } else {
      const pickUpValue = yield select(getPickupValues);
      const storeDetails = yield select(BagPageSelectors.getBossBopisStore);
      const isValidStoreType = Array.isArray(storeDetails);
      const firstStore = isValidStoreType && storeDetails[0];
      const { addressLine1, addressLine2, city, state, zipCode, country } = getStoreAddress(
        firstStore?.address
      );
      billingAddress = {
        address1: addressLine1,
        address2: addressLine2,
        c_addressId: null,
        c_addressName: null,
        c_addressType: null,
        c_emailAddress: emailAddress,
        c_sameAsShippingAddress: true,
        city,
        countryCode: country,
        firstName: pickUpValue?.firstName,
        lastName: pickUpValue?.lastName,
        phone: phoneNumber,
        postalCode: zipCode,
        stateCode: state,
      };
    }
    // TODO: Remove the logger once the RC is fixed for missing address
    if (!billingAddress?.address1) {
      const totalItems = yield select(BagPageSelectors.getTotalItemsCheck);
      const isGuestUser = yield select(isGuest);
      logger.error({
        error: 'Venmo missing billing address in submit order',
        extraData: {
          orderItems: JSON.stringify(orderItems),
          hasEcomItems,
          totalItems,
          emailExist: !!emailAddress,
          isGuestUser,
        },
      });
      if (address.addressLine1) {
        billingAddress = getBillingAddress(address, email, phoneNumber);
        if (!billingAddress?.address1) {
          // This log is to check the number of sessions passed after setting shipping address
          logger.error({
            error: 'Venmo missing billing address in submit order retry',
            extraData: {
              hasEcomItems,
              totalItems,
            },
          });
        }
      }
    }

    venmoPayload = {
      billingAddress,
      deviceData: venmoDeviceData,
      paymentMethod: PAYMENT_METHOD_VENMO,
      paymentNonce: venmoNonce,
      saveToProfile: isVenmoSaveSelected,
      venmoUserId: username || userName,
    };
    res = yield call(appleVenmoSubmitOrderFn, venmoPayload, errorMappings);
  } else {
    res = yield call(submitOrderFn, errorMappings, adyenRequest);
  }

  yield put(resetCartCache());
  yield InjectConfirmationDynamicStore();
  yield put(getSetOrderConfirmationActn(res));
  return res;
}

export function* expressCheckoutSubmit(formData) {
  // if express checkout
  const { billing, hasAlternatePickup } = formData; // /* giftWrap, disabled */
  /* istanbul ignore else */
  if (hasAlternatePickup) {
    yield call(callPickupSubmitMethod, formData);
  }

  // const giftWrapPromise = Promise.resolve();

  /* istanbul ignore else */
  if (billing && billing.cvv) {
    // PLCC does not require CVV -> billing = null. User entered a cvv for a credit card
    // submit CVV
    const billingDetails = yield select(getBillingValues);
    const grandTotal = yield select(getGrandTotal);
    const requestData = {
      orderGrandTotal: grandTotal,
      monthExpire: billingDetails.billing.expMonth,
      yearExpire: billingDetails.billing.expYear,
      cardType: billingDetails.billing.cardType,
      cardNumber: billingDetails.billing.cardNumber,
      paymentId: billingDetails.paymentId,
      billingAddressId: billingDetails.address.onFileAddressId, // DT-34037 billing_address_id need to be send along with updatePayment.
      cvv: billing.cvv, // the cvv entered by the user
      recaptchaToken: billingDetails.recaptchaToken,
    };
    const result = yield call(updatePaymentOnOrder, requestData);
    if (result && result.paymentId) {
      billingDetails.paymentId = result.paymentId;
      yield put(getSetBillingValuesActn(billingDetails));
    }
  }
}

/**
 * @description calling this method on guest order submit, as BE needed to get the cookies and based on that associate
 * recent order
 * @param {bool} isGuestUser
 */
export function* triggerNavigateXHRAPICall(isGuestUser) {
  if (isGuestUser) {
    yield put(navigateXHRAction());
  }
}

export function* fetchCoupons(isCouponAppliedInOrder) {
  if (isCouponAppliedInOrder) {
    yield injectCouponDynamicStore();
    yield put(getCouponList({ ignoreCache: true }));
  }
}
export function* removeData() {
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  if (!isLoginV2FlowEnabled) {
    removeSessionStorage(CONTACT_FORM);
  }
  yield put(isExpressUserCallDone(false));
  yield put(isNonCachedCartDataCallDone(false));
}

export function* navigateToNextScreen({ callback, navigation }) {
  /** callback: using to navigate from the action triggered. This is used to hold the screen for sometime then navigate */
  if (callback) {
    yield call(callback);
  } else if (navigation) {
    navigation.navigate(constants.CHECKOUT_ROUTES_NAMES.CHECKOUT_CONFIRMATION);
  }
}

// method to handle submit of order in review page
// eslint-disable-next-line complexity
/* eslint-disable max-statements */

const handleNavigation = () => {
  utility.routeToPage(CHECKOUT_ROUTES.spcConfirmationPage);
};
// eslint-disable-next-line sonarjs/cognitive-complexity
function* submitOrderForProcessing({
  payload: {
    navigation,
    formData,
    hideLoader,
    token = '',
    isPlccInstantCheckout,
    navigationActions,
    isExpressAfterPayPayment,
    adyenRequest,
    adyenComponent,
    fromAdyenPayPal,
    isMiniBag,
  } = {},
}) {
  try {
    yield put(setExpressAfterPayDone(isExpressAfterPayPayment));
    yield InjectConfirmationDynamicStore();
    const submitOrderButtonState = yield select(getSubmitOrderButtonState);
    if (submitOrderButtonState !== SUBMIT_ORDER_BUTTON_STATE.LOADING) {
      yield put(setSubmitOrderError(false));
      yield put(setSubmitOrderErrorCode(''));
      const orderId = yield select(getCurrentOrderId);
      const smsOrderInfo = yield select(getSmsNumberForBillingOrderUpdates);
      const currentLanguage = yield select(getCurrentLanguage);
      const isExpressCheckoutEnabled = yield select(isExpressCheckout);
      const pendingPromises = [];
      if (!hideLoader && !isExpressAfterPayPayment) {
        yield put(setLoaderState(true));
      }
      yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.LOADING));
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: true }));
      yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
      if (isExpressCheckoutEnabled && formData) {
        yield call(expressCheckoutSubmit, formData);
      }

      yield all(pendingPromises);
      const cartOrderItems = yield select(BagPageSelectors.getOrderItems);
      yield put(setOrderDetailsForConfirmation(cartOrderItems));
      const res = yield call(
        submitOrderProcessing,
        adyenRequest,
        orderId,
        smsOrderInfo,
        currentLanguage
      );
      if (res) yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.SUCCESS));
      // setting up current checkout stage.
      yield put(getSetCheckoutStage(constants.CHECKOUT_STAGES.CONFIRMATION));
      const isPlccIC = yield select(getIsPlccCheckoutEnabled);
      // Need to move user on confirmation page ASAP in web
      handleNavigation();
      yield fork(loadPersonalizedCoupons, { token, ...res });
      const cartItems = yield select(BagPageSelectors.getOrderItems);
      const email = res.userDetails ? res.userDetails.emailAddress : res.shipping.emailAddress;
      const isCaSite = yield call(isCanada);
      const isGuestUser = yield select(isGuest);
      const { tcpProducts, gymProducts, snjProducts, pjpProducts } = yield select(
        BagPageSelectors.getProductsTypes
      );
      /* istanbul ignore else */
      // const vendorId =
      //   cartItems.size > 0 && cartItems.getIn(['0', 'miscInfo', 'vendorColorDisplayId']);
      yield put(getSetOrderProductDetails(cartItems));
      yield put(resetAirmilesReducer());
      yield injectCouponDynamicStore();
      yield put(resetCouponReducer());
      if (!isExpressAfterPayPayment) {
        yield put(setLoaderState(false));
      }
      // making loader true for submit order button since the confirmation page is taking time to load
      if (isPlccIC || adyenRequest?.paymentData) {
        yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
      }
      yield call(removeData);
      yield put(setCouponLoadingState(false));
      if (!isGuestUser) {
        yield fork(getUserInfoSaga, { payload: { reloadUserInfo: true, refresh: true } });
      }
      if (isGuestUser && !isCaSite && email) {
        yield fork(
          validateAndSubmitEmailSignup,
          email,
          'us_guest_checkout',
          tcpProducts.length > 0,
          gymProducts.length > 0,
          snjProducts.length > 0,
          pjpProducts.length > 0
        );
      }
      yield ApplyCardDynamicStore();
      yield put(resetPLCCInstantCardApplication());
      yield put(setApplePayDefault(true));
      if (isExpressAfterPayPayment) {
        yield put(setSpcButtonLoader({ id: 'submitOrderBtn', isLoading: false }));
      }
      yield put(setExpressAfterpayFlow(false));
      const isBonusPointDayEnabled = yield select(getIsBonusPointDayEnabled);
      if (isBonusPointDayEnabled) {
        const bonusPointDay = !isGuestUser
          ? yield call(getBonusPointsDayAbstractor, undefined, true)
          : [];
        yield put(setBonusPointDay(bonusPointDay));
      }
      yield fork(triggerNavigateXHRAPICall, isGuestUser);
    }
  } catch (e) {
    if (isExpressAfterPayPayment) {
      const isBagPage = window?.location?.pathname?.indexOf('/bag') !== -1;
      yield put(getSetBillingValuesActn({}));
      yield put(setSpcButtonLoader({ id: 'submitOrderBtn', isLoading: false }));
      if (isBagPage) {
        utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
      } else {
        yield put(setAfterPayPaymentProgress(false));
      }
    }
    if (adyenComponent && fromAdyenPayPal) {
      const isBagPage = window?.location?.pathname?.indexOf('/bag') !== -1;

      if (isBagPage) {
        utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
      }
    }
    if (adyenComponent && adyenComponent.setElementStatus) {
      adyenComponent.setElementStatus('ready');
    }
    yield put(triggerCheckoutWithPayment(false));
    yield put(setCouponLoadingState(false));
    yield put(resetCartCache());
    yield put(
      BAG_PAGE_ACTIONS.getNonCachedCartData({
        disableLoading: !isPlccInstantCheckout,
        isCheckoutFlow: true,
        ignoreCache: true,
      })
    );
    yield put(recalibrateSectionStates());
    const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
    const billingError = getServerErrorMessage(e, errorsMapping);
    yield put(setLoaderState(false));
    yield put(updateSubmitOrderButtonState(SUBMIT_ORDER_BUTTON_STATE.NORMAL));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: billingError,
        component: isExpressAfterPayPayment ? 'AfterPay' : 'PAGE',
        isSubmitOrderError: true,
        errorCode: e?.errorCodes || '',
      })
    );
    if (fromAdyenPayPal && isMiniBag) {
      yield put(AddToCartError(billingError));
    }
    yield put(BAG_PAGE_ACTIONS.setAfterPayPopupOpen(false));
    yield put(setSubmitOrderError(true));
    yield put(setSubmitOrderErrorCode(e?.errorCodes));
    if (isPlccInstantCheckout) {
      yield put(isExpressCallThroughPlccICFailure(true));
      yield put(
        BAG_PAGE_ACTIONS.startCheckout({
          isBagPage: true,
          isPlccInstantCheckout: true,
          navigation,
          navigationActions,
          spcPage: true,
        })
      );
    }
    logger.error({
      error: 'Error in submitOrderForProcessing',
      extraData: {
        component: 'CheckoutReview Saga - submitOrderForProcessing',
        errorMessage: JSON.stringify(e),
        isPlccInstantCheckout,
        isExpressAfterPayPayment,
      },
    });
    if (hideLoader && !isPlccInstantCheckout) {
      throw e;
    }
  }
  // eslint-disable-next-line max-lines
}

export default submitOrderForProcessing;
